import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getMarginHistory } from "../../Redux/Actions/rentalPropertiesActions";

const MarginHistoryModal = ({ isOpen, onClose, propertyId, filterActions }) => {
  const dispatch = useDispatch();
  const { marginHistory } = useSelector((state) => state.propertyRental);

  useEffect(() => {
    if (isOpen && propertyId) dispatch(getMarginHistory(propertyId));
  }, [isOpen, propertyId]);

  if (!isOpen) return null;

  const allHistory = marginHistory?.history || [];
  const filtered = [...allHistory].reverse().filter((item) => filterActions.includes(item.action));

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.modal} onClick={(e) => e.stopPropagation()}>

        <div style={styles.header}>
          <div style={styles.headerLeft}>
            <div style={styles.iconBox}>🕒</div>
            <div>
              <h2 style={styles.title}>Margin History</h2>
              <p style={styles.subtitle}>{filtered.length} record{filtered.length !== 1 ? "s" : ""} found</p>
            </div>
          </div>
          <button style={styles.closeBtn} onClick={onClose}>✖</button>
        </div>

        <div style={styles.listWrapper}>
          {filtered.length > 0 ? (
            <div style={styles.list}>
              {filtered.map((item, index) => (
                <div key={index} style={styles.item}>

                  <div style={styles.itemHeader}>
                    <span style={{
                      ...styles.badge,
                      background: item.action?.includes("add") ? "rgba(16,185,129,0.1)" : "rgba(44,71,145,0.08)",
                      color: item.action?.includes("add") ? "#10b981" : "#2c4791",
                      border: `1px solid ${item.action?.includes("add") ? "rgba(16,185,129,0.2)" : "rgba(44,71,145,0.2)"}`,
                    }}>
                      {item.action === "add_admin_margin" && "➕ Added Admin Margin"}
                      {item.action === "update_admin_margin" && "✏️ Updated Admin Margin"}
                      {item.action === "add_margin_ratio" && "➕ Added Margin Ratio"}
                      {item.action === "update_margin_ratio" && "✏️ Updated Margin Ratio"}
                    </span>
                    <span style={styles.time}>
                      🗓 {item.changed_at
                        ? new Date(item.changed_at).toLocaleString("en-IN", {
                            day: "2-digit", month: "short", year: "numeric",
                            hour: "2-digit", minute: "2-digit",
                          })
                        : "N/A"}
                    </span>
                  </div>

                  <div style={styles.dataRow}>

                    {item.admin_margin?.type && (
                      <>
                        <div style={styles.chip}>
                          <span style={styles.chipLabel}>TYPE</span>
                          <span style={styles.chipValue}>
                            {item.admin_margin.type === "percentage" && "% Percentage"}
                            {item.admin_margin.type === "flat" && "₹ Flat"}
                            {item.admin_margin.type === "per_sq_ft" && "□ Per Sq.ft"}
                          </span>
                        </div>
                        <div style={styles.chip}>
                          <span style={styles.chipLabel}>VALUE</span>
                          <span style={styles.chipValue}>
                            {item.admin_margin.type === "percentage"
                              ? `${item.admin_margin.margin}%`
                              : `₹ ${Number(item.admin_margin.margin).toLocaleString("en-IN")}`}
                          </span>
                        </div>
                      </>
                    )}

                    {(item.margin_ratio?.agent_margin != null || item.margin_ratio?.admin_margin != null) && (
                      <>
                        <div style={styles.chip}>
                          <span style={styles.chipLabel}>AGENT</span>
                          <span style={styles.chipValue}>{item.margin_ratio.agent_margin ?? 0}%</span>
                        </div>
                        <div style={styles.chip}>
                          <span style={styles.chipLabel}>ADMIN</span>
                          <span style={styles.chipValue}>{item.margin_ratio.admin_margin ?? 0}%</span>
                        </div>
                        <div style={styles.chip}>
                          <span style={styles.chipLabel}>TOTAL</span>
                          <span style={{ ...styles.chipValue, color: "#10b981" }}>
                            {(item.margin_ratio.agent_margin ?? 0) + (item.margin_ratio.admin_margin ?? 0)}%
                          </span>
                        </div>
                      </>
                    )}

                    <div style={styles.chip}>
                      <span style={styles.chipLabel}>CHANGED BY</span>
                      <span style={styles.chipValue}>{item.changed_by || "Admin"}</span>
                    </div>

                    {item.ip_address && (
                      <div style={styles.chip}>
                        <span style={styles.chipLabel}>IP</span>
                        <span style={styles.chipValue}>{item.ip_address}</span>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div style={styles.empty}>
              <span style={{ fontSize: "32px" }}>📭</span>
              <p style={{ color: "#94a3b8", fontSize: "14px", fontStyle: "italic", margin: 0 }}>No history found</p>
            </div>
          )}
        </div>

        <div style={styles.footer}>
          <button style={styles.closeFooterBtn} onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
    background: "rgba(0,0,0,0.55)", backdropFilter: "blur(8px)",
    display: "flex", alignItems: "center", justifyContent: "center",
    zIndex: 10001, 
  },
  modal: {
    background: "#ffffff", borderRadius: "24px",
    width: "100%", maxWidth: "560px",
    border: "1px solid #e2e8f0",
    boxShadow: "0 24px 60px rgba(0,0,0,0.15)",
    display: "flex", flexDirection: "column",
    maxHeight: "80vh",
  },
  header: {
    display: "flex", justifyContent: "space-between",
    alignItems: "flex-start",
    padding: "24px 28px 20px 28px",
    borderBottom: "1px solid #f1f5f9",
  },
  headerLeft: { display: "flex", alignItems: "center", gap: "14px" },
  iconBox: {
    fontSize: "26px",
    background: "rgba(44,71,145,0.08)",
    border: "1px solid rgba(44,71,145,0.2)",
    borderRadius: "14px", padding: "10px",
    display: "flex", alignItems: "center", justifyContent: "center",
  },
  title: { color: "#0f172a", fontSize: "18px", fontWeight: 700, margin: 0 },
  subtitle: { color: "#64748b", fontSize: "13px", margin: "4px 0 0 0" },
  closeBtn: {
    background: "#f1f5f9", border: "1px solid #e2e8f0",
    color: "#64748b", borderRadius: "50%",
    width: "36px", height: "36px",
    display: "flex", alignItems: "center", justifyContent: "center",
    cursor: "pointer", fontSize: "14px",
  },
  listWrapper: {
    overflowY: "auto", padding: "20px 28px",
    flex: 1,
  },
  list: { display: "flex", flexDirection: "column", gap: "12px" },
  item: {
    background: "#f8fafc", borderRadius: "12px",
    padding: "14px", border: "1px solid #f1f5f9",
    display: "flex", flexDirection: "column", gap: "10px",
  },
  itemHeader: {
    display: "flex", justifyContent: "space-between",
    alignItems: "center", flexWrap: "wrap", gap: "8px",
  },
  badge: {
    padding: "4px 12px", borderRadius: "20px",
    fontSize: "12px", fontWeight: 600,
  },
  time: { color: "#94a3b8", fontSize: "11px", fontWeight: 500 },
  dataRow: { display: "flex", gap: "8px", flexWrap: "wrap" },
  chip: {
    background: "#fff", borderRadius: "8px",
    padding: "6px 12px", border: "1px solid #e2e8f0",
    display: "flex", flexDirection: "column", gap: "2px",
  },
  chipLabel: { fontSize: "10px", color: "#94a3b8", fontWeight: 600 },
  chipValue: { fontSize: "12px", color: "#0f172a", fontWeight: 700 },
  empty: {
    display: "flex", flexDirection: "column",
    alignItems: "center", justifyContent: "center",
    gap: "12px", padding: "40px",
    background: "#f8fafc", borderRadius: "12px",
    border: "1px dashed #cbd5e1",
  },
  footer: {
    padding: "16px 28px",
    borderTop: "1px solid #f1f5f9",
  },
  closeFooterBtn: {
    width: "100%", padding: "12px",
    background: "#f8fafc", border: "1px solid #e2e8f0",
    borderRadius: "12px", color: "#64748b",
    fontSize: "14px", fontWeight: 600, cursor: "pointer",
  },
};

export default MarginHistoryModal;